import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { DealerComponent } from './dealer.component';
import { AuthGuard } from 'src/app/auth/auth.guard';
import { DealerAccountComponent } from './dealer-account/dealer-account.component';
import { JobSearchComponent } from './job-search/job-search.component';
import { DealerSearchComponent } from 'src/app/public/account/elements/dealer-search/dealer-search.component';

const routesOld: Routes = [
  {
    path: '', component: DealerComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: DealerAccountComponent },

      //{ path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent },

      //{ path: 'public', component: DealerPublicComponent },

      { path: 'search', component: DealerSearchComponent },
      { path: 'job-search', component: JobSearchComponent },

      // { path: 'dashboard', canActivate: [AuthGuard], component: CustomerDashboardComponent },
      // { path: 'account', canActivate: [AuthGuard], component: CustomerAccountComponent },

      // { path: 'buy', canActivate: [AuthGuard], component: CustomerBuyComponent  },
      // { path: 'rent', canActivate: [AuthGuard], component: CustomerRentComponent  },
      // { path: 'appointments', canActivate: [AuthGuard], component: CustomerRentComponent  },

      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];


const routes: Routes = [
  {
    path: '', component: DealerComponent,
    children: [
      { path: '', canActivate: [AuthGuard], component: DealerAccountComponent },

      //{ path: 'appointments', canActivate: [AuthGuard], component: DealerAppointmentsComponent },

      //{ path: 'public', component: DealerPublicComponent },

      { path: 'search', component: DealerSearchComponent },
      { path: 'job-search', component: JobSearchComponent },

      // { path: 'dashboard', canActivate: [AuthGuard], component: CustomerDashboardComponent },
      // { path: 'account', canActivate: [AuthGuard], component: CustomerAccountComponent },

      // { path: 'buy', canActivate: [AuthGuard], component: CustomerBuyComponent  },
      // { path: 'rent', canActivate: [AuthGuard], component: CustomerRentComponent  },
      // { path: 'appointments', canActivate: [AuthGuard], component: CustomerRentComponent  },

      //{ path: '', redirectTo: '/admin/home', pathMatch: 'full' },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class DealerRoutingModule { }
